"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCategroy = addCategroy;
exports.categroyByIds = categroyByIds;
exports.categroyUpdateStatus = categroyUpdateStatus;
exports.deleteCategroy = deleteCategroy;
exports.infoCategroy = infoCategroy;
exports.treeCategroy = treeCategroy;
exports.updateCategroy = updateCategroy;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 新增分类
 * @param params
 */
function addCategroy(params) {
  var data = {
    extra: params.extra,
    name: params.name,
    pid: params.pid,
    sort: params.sort,
    status: params.status,
    type: params.type,
    url: params.url
  };
  return (0, _request.default)({
    url: 'admin/platform/category/save',
    method: 'POST',
    data: data
  });
}

/**
 * 分类详情
 * @param params
 */
function infoCategroy(id) {
  return (0, _request.default)({
    url: "admin/platform/category/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 删除分类
 * @param params
 */
function deleteCategroy(id) {
  return (0, _request.default)({
    url: "admin/platform/category/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 分类数据tree数据
 * @param params
 */
function treeCategroy(params) {
  var data = {
    type: params.type,
    status: params.status,
    name: params.name
  };
  return (0, _request.default)({
    url: 'admin/platform/category/list/tree',
    method: 'GET',
    params: data
  });
}

/**
 * 更新分类
 * @param params
 */
function updateCategroy(params) {
  var data = {
    extra: params.extra,
    name: params.name,
    pid: params.pid,
    sort: params.sort,
    status: params.status,
    type: params.type,
    url: params.url,
    id: params.id
  };
  return (0, _request.default)({
    url: "admin/platform/category/update/".concat(params.id),
    method: 'POST',
    data: data
  });
}

/**
 * 根据id集合查询对应分类列表
 * @param params
 */
function categroyByIds(params) {
  var data = {
    ids: params.ids
  };
  return (0, _request.default)({
    url: 'admin/platform/category/list/ids',
    method: 'GET',
    params: data
  });
}

/**
 * 修改 显示关闭状态
 * @param params
 */
function categroyUpdateStatus(id) {
  return (0, _request.default)({
    url: "admin/platform/category/updateStatus/".concat(id),
    method: 'post'
  });
}